import CryptoJS from 'crypto-js';

export const createPKCE = () => {
  // Mock PKCE for vitest
  if (typeof process !== 'undefined' && process?.env?.VITEST_WORKER_ID) {
    return {
      codeVerifier: 'jccctzphkyesxnopzkmjdghxsepogslb',
      codeChallenge: 'stesxapcwinietftywocyvoksbrnrccc',
    };
  }

  const randomBytes = CryptoJS.lib.WordArray.random(32);
  const codeVerifier = CryptoJS.enc.Base64.stringify(randomBytes)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
  const codeChallenge = CryptoJS.SHA256(codeVerifier)
    .toString(CryptoJS.enc.Base64)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  return {
    codeVerifier,
    codeChallenge,
    randomBytes: randomBytes.toString(),
    codeMethod: 'S256',
  };
};
